import {css} from 'lit';
export const styles = css`.calendar-opened {
  display: block;
}

.calendar-closed {
  display: none;
}`;
export default styles;
